"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ActionMessage_1 = __importDefault(require("@/Jetstream/ActionMessage"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var FormSection_1 = __importDefault(require("@/Jetstream/FormSection"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var InputError_1 = __importDefault(require("@/Jetstream/InputError"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
function UpdatePasswordForm() {
    var route = (0, useRoute_1.default)();
    var form = (0, inertia_react_1.useForm)({
        current_password: '',
        password: '',
        password_confirmation: '',
    });
    var passwordRef = (0, react_1.useRef)(null);
    var currentPasswordRef = (0, react_1.useRef)(null);
    function updatePassword() {
        form.put(route('user-password.update'), {
            errorBag: 'updatePassword',
            preserveScroll: true,
            onSuccess: function () { return form.reset(); },
            onError: function () {
                var _a, _b;
                if (form.errors.password) {
                    form.reset('password', 'password_confirmation');
                    (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                if (form.errors.current_password) {
                    form.reset('current_password');
                    (_b = currentPasswordRef.current) === null || _b === void 0 ? void 0 : _b.focus();
                }
            },
        });
    }
    return (react_1.default.createElement(FormSection_1.default, { onSubmit: updatePassword, title: 'Update Password', description: 'Ensure your account is using a long, random password to stay secure.', renderActions: function () { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ActionMessage_1.default, { on: form.recentlySuccessful, className: "mr-3" }, "Saved."),
            react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)({ 'opacity-25': form.processing }), disabled: form.processing }, "Save"))); } },
        react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
            react_1.default.createElement(Label_1.default, { htmlFor: "current_password" }, "Current Password"),
            react_1.default.createElement(Input_1.default, { id: "current_password", type: "password", className: "mt-1 block w-full", ref: currentPasswordRef, value: form.data.current_password, onChange: function (e) {
                    return form.setData('current_password', e.currentTarget.value);
                }, autoComplete: "current-password" }),
            react_1.default.createElement(InputError_1.default, { message: form.errors.current_password, className: "mt-2" })),
        react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
            react_1.default.createElement(Label_1.default, { htmlFor: "password" }, "New Password"),
            react_1.default.createElement(Input_1.default, { id: "password", type: "password", className: "mt-1 block w-full", value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); }, autoComplete: "new-password", ref: passwordRef }),
            react_1.default.createElement(InputError_1.default, { message: form.errors.password, className: "mt-2" })),
        react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
            react_1.default.createElement(Label_1.default, { htmlFor: "password_confirmation" }, "Confirm Password"),
            react_1.default.createElement(Input_1.default, { id: "password_confirmation", type: "password", className: "mt-1 block w-full", value: form.data.password_confirmation, onChange: function (e) {
                    return form.setData('password_confirmation', e.currentTarget.value);
                }, autoComplete: "new-password" }),
            react_1.default.createElement(InputError_1.default, { message: form.errors.password_confirmation, className: "mt-2" }))));
}
exports.default = UpdatePasswordForm;
